export const REGIONS = ['Central', 'Western', 'Eastern', 'Other']
export const REPORT_TYPES = [
  'Fraud',
  'Irregularity',
  'Financial & Administrative Corruption',
  'Other',
]
